<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage :page-titles="pageTitles" hide-button="true" />
      <b-form @submit.prevent.stop="save">
        <b-row>
          <b-col cols="12">
            <b-form-group label="Patrimônio" label-for="patrimony">
              <b-form-input
                id="patrimony"
                v-model="patrimony"
                type="text"
                :state="entrega.patrimony ? true : null"
                placeholder="Patrimônio do equipamento a ser devolvido (incluindo zeros)"
                required
                @change="loadPatrimony"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group label="Nome" label-for="nome">
              <b-form-input
                id="nome"
                v-model="entrega.fullName"
                placeholder="Preencha o patrimônio do equipamento"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group label="Empresa" label-for="empresa">
              <b-form-input
                id="empresa"
                v-model="entrega.company"
                placeholder="Preencha o patrimônio do equipamento"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group label="CPF" label-for="cnpjCpf">
              <b-form-input
                id="cnpjCpf"
                v-model="entrega.cpf"
                placeholder="Preencha o patrimônio do equipamento"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="12" cols="12" class="mt-3">
            <div class="between">
              <b-form-group
                label="Equipamento em operação"
                label-for="equipmentOperating"
              />
              <b-form-checkbox
                id="equipmentOperating"
                v-model="entrega.equipmentOperating"
                switch
              />
            </div>
          </b-col>
          <b-col md="12" cols="12" class="mt-2">
            <div class="between">
              <b-form-group
                label="Equipamento limpo"
                label-for="equipmentClear"
              />
              <b-form-checkbox
                id="equipmentClear"
                v-model="entrega.equipmentClear"
                switch
              />
            </div>
          </b-col>
          <b-col md="12" cols="12" class="mt-2">
            <div class="between">
              <b-form-group
                label="Equipamento danificado"
                label-for="equipmentDamaged"
              />
              <b-form-checkbox
                id="equipmentDamaged"
                v-model="entrega.equipmentDamaged"
                switch
              />
            </div>
          </b-col>
          <b-col cols="12" md="12" class="mt-2">
            <b-form-group label="Acessórios" label-for="accessories">
              <multiselect
                id="accessories"
                v-model="entrega.accessories"
                :options="accessories"
                :close-on-select="false"
                label="text"
                track-by="value"
                selected-label="Selecionado"
                deselect-label="Remover"
                select-label="Adicionar"
                placeholder="Selecione os acessórios"
                :disabled="!accessoriesOk"
                :loading="isLoading"
                multiple
              >
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col md="12" cols="12" class="mt-2">
            <div class="between">
              <b-form-group
                label="Acessórios divergentes"
                label-for="accessoriesOk"
              />
              <b-form-checkbox
                id="accessoriesOk"
                v-model="accessoriesOk"
                switch
              />
            </div>
          </b-col>
        </b-row>
        <!-- <b-row align-h="end" class="mr-1"> -->
        <b-button
          v-if="equipment && patrimony"
          variant="primary"
          class="mt-3"
          type="submit"
        >
          Salvar
        </b-button>
        <!-- </b-row> -->
      </b-form>
    </div>
    <b-modal
      id="modal-1"
      v-model="modalAlertOpen"
      size="lg"
      title="Atenção"
      ok-title="Sim"
      cancel-title="Não"
      ok-variant="danger"
      cancel-variant="outline-primary"
      @ok="confirmStatus = true"
    >
      <p align="justify"
        >O Status do equipamento não foi alterado, você confirma?</p
      >
    </b-modal>
    <b-modal
      id="modal-2"
      v-model="modalAlertAccessories"
      size="lg"
      title="Atenção"
      ok-title="Sim"
      cancel-title="Não"
      ok-variant="danger"
      cancel-variant="outline-primary"
      @ok="confirmStatusAccessories = true"
    >
      <p align="justify"
        >Você informou que os acessórios divergem, porém não alterou a
        informação de quais acessórios estão sendo entregues com o equipamento.
        Você confirma?</p
      >
    </b-modal>
    <b-modal
      id="modal-2"
      v-model="modalAlertOperating"
      size="lg"
      title="Atenção"
      ok-title="Sim"
      cancel-title="Não"
      ok-variant="danger"
      cancel-variant="outline-primary"
      @ok="confirmStatusOperating = true"
    >
      <p align="justify"
        >Você informou que o equipamento está fora de operação. Você
        confirma?</p
      >
    </b-modal>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import alertMixin from '@/src/mixins/alertMixin'
import HeaderPage from '@/src/components/register/header-page.vue'
import Multiselect from 'vue-multiselect'
import serviceReturnEquipments from '@/src/services/serviceReturnEquipments'

export default {
  components: {
    Layout,
    HeaderPage,
    Multiselect,
  },
  mixins: [alertMixin],
  data() {
    return {
      accessories: [
        { text: 'Talhadeira', value: 'talhadeira' },
        { text: 'Ponteiro', value: 'ponteiro' },
        { text: 'Mangueira', value: 'mangueira' },
        { text: 'Extensão', value: 'extensão' },
        { text: 'Disco', value: 'disco' },
      ],
      accessoriesOk: false,
      patrimony: '',
      isLoading: false,
      pageTitles: {
        title: 'Registro de Retorno de Equipamentos',
        subtitle: 'Controle de Equipamentos',
      },
      entrega: {},
      modalAlertOpen: false,
      modalAlertAccessories: false,
      modalAlertOperating: false,
      confirmStatus: false,
      confirmStatusAccessories: false,
      confirmStatusOperating: false,
    }
  },
  methods: {
    async loadPatrimony() {
      this.isLoading = true

      serviceReturnEquipments
        .findReturn(this.patrimony)
        .then((response) => {
          this.accessoriesOk = false
          this.confirmStatus = false
          this.confirmStatusAccessories = false
          this.confirmStatusOperating = false
          this.entrega = response.data
          this.equipment = response.data.equipment.find(
            (item) => String(item.patrimony) === String(this.patrimony)
          )
          this.entrega.accessories = this.accessories.filter((item) =>
            response.data.accessories.includes(item.text)
          )
          this.entrega.equipmentClear = false
          this.entrega.equipmentDamaged = false
          this.entrega.equipmentOperating = false
          this.entrega.cpf = this.entrega.cpf.replace(
            /(\d{3})(\d{3})(\d{3})(\d{2})/,
            '$1.$2.$3-$4'
          )

          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.accessoriesOk = false

          this.equipment = null
          this.confirmStatus = false
          this.confirmStatusAccessories = false
          this.confirmStatusOperating = false
          this.errorMessage(error.response.data.error.message)
        })
    },
    validation() {
      if (
        !this.entrega.equipmentOperating &&
        !this.entrega.equipmentClear &&
        !this.entrega.equipmentDamaged &&
        !this.confirmStatus
      ) {
        this.modalAlertOpen = true

        return false
      }

      if (this.accessoriesOk) {
        console.log('aqui')
        let arrAccessories = this.equipment.accessories.split(',')
        let newArrAccessories = []
        let oldArrAccessories = []

        this.accessories.map((item) => {
          if (arrAccessories.includes(item.value)) {
            oldArrAccessories.push(item.value)
          }
        })

        this.entrega.accessories.map((item) => {
          newArrAccessories.push(item.value)
        })

        newArrAccessories.sort()
        oldArrAccessories.sort()
        if (
          JSON.stringify(oldArrAccessories) ===
          JSON.stringify(newArrAccessories)
        ) {
          if (!this.confirmStatusAccessories) {
            this.modalAlertAccessories = true

            return false
          } else {
            this.accessoriesOk = false
          }
        }
      }
      if (!this.entrega.equipmentOperating && !this.confirmStatusOperating) {
        this.modalAlertOperating = true

        return false
      }

      return true
    },
    save() {
      if (this.validation()) {
        this.isLoading = true
        const accessories = []
        let data = {
          patrimony: this.patrimony,
          equipmentOperating: this.entrega.equipmentOperating,
          equipmentClear: this.entrega.equipmentClear,
          equipmentDamaged: this.entrega.equipmentDamaged,
          accessoriesOk: !this.accessoriesOk,
        }

        if (this.accessoriesOk) {
          this.entrega.accessories.map((item) => {
            accessories.push(item.value)
          })

          data['accessories'] = accessories
        }

        serviceReturnEquipments
          .return(data)
          .then((_response) => {
            this.isLoading = false
            this.successMessage('Equipamento devolvido com sucesso.')
            this.patrimony = ''
            this.entrega = {}
            this.equipment = null
            this.accessoriesOk = false
          })
          .catch((error) => {
            this.isLoading = false
            this.errorMessage(error.response.data.error.message)
          })
      }
    },
  },
}
</script>

<style>
.between {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
</style>

<style src="../style.scss" lang="scss">
</style>
